import React from 'react';
import styled from 'styled-components';
import { boxShadows } from '../../../../shared/lib/styles';
import Box from '../../../../shared/spa/core-components/Box';
import Accordion from '../../../../shared/components/Accordion';
import { ButtonAccordionItem } from '../../../../shared/components/Accordion/AccordionItem';
import Heading from '../../../../shared/components/Heading';
import Image from '../../../../shared/components/Image';
import Paragraph from '../../../../shared/components/Paragraph';
import { trackEvent } from '@99designs/tracking';
import { getWebBuilders } from '../../WebBuilderSelector/webBuilders';
import { useIntl } from 'react-intl';

const ShadowBox = styled(Box)`
    box-shadow: ${boxShadows.medium};
`;

interface ButtonAccordionProps {
    category: string;
    items: {
        id: string;
        title: string;
        child: string;
    }[];
}

const ButtonAccordion = ({ category, items }: ButtonAccordionProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function handleOpen({ title }: { title: any }) {
        trackEvent('Clicked Web Builder Recommendation', {
            category,
            recommendation: title,
        });
    }

    return (
        <Accordion spaceBetween="space7">
            {items.map((item) => (
                <ButtonAccordionItem
                    key={item.title}
                    id={item.id}
                    title={item.title}
                    onOpen={handleOpen}
                >
                    {item.child}
                </ButtonAccordionItem>
            ))}
        </Accordion>
    );
};

export interface CategoryType {
    id: string;
    description: string;
    image: string;
    recommendations: string[];
    title: string;
}

function Category({ description, id, image, recommendations, title }: CategoryType) {
    const intl = useIntl();
    const products = getWebBuilders();
    const items = recommendations.reduce(
        (items: { id: string; child: string; title: string }[], recommendation) => {
            const recommendedProduct = products[recommendation];
            if (!recommendedProduct.isAvailableForLocale(intl.locale)) {
                return items;
            }

            const { blurb: child, title } = recommendedProduct;
            items.push({
                id,
                child,
                title,
            });
            return items;
        },
        []
    );

    return (
        <Box>
            <ShadowBox marginBottom="space9">
                <Image src={image} />
            </ShadowBox>
            <Heading type="h4" variations={['h4']}>
                {title}
            </Heading>
            <Paragraph>{description}</Paragraph>
            <Paragraph>{__("We'd recommend:")}</Paragraph>
            <ButtonAccordion category={id} items={items} />
        </Box>
    );
}

export default Category;
